import * as React from "react";
import { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import DashboardViewService from "../services/dashboardview.service.js";
import TableViewService from "../services/tableview.service.js";
import RecipeViewService from "../services/recipe.service.js";
import BatchDataService from '../services/batchdata.service.js';
import AlarmViewService from "../services/alarmview.service.js";
import TrendViewService from "../services/trendview.service.js";
import ReportViewService from "../services/reportview.service.js";
import ReportViewComplienceService from "../services/reportviewcomplience.service";
import AuditTrailViewService from "../services/audittrailview.service.js";
import UserManagementService from "../services/usermanagement.service.js";
import ConfigurationViewService from "../services/configurationview.service";

import { useDispatch, useSelector } from "react-redux";
import {
  setGroupName,
  setWidgetName,
  setWidgetDescription,
} from "../slices/splitbutton12.js";

export default function SplitButton12({
  projectName,
  dashboardType,
  selectedDashboardGroup,
  selectedDashboard,
}) {
  
  const [open, setOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedIndexDashboard, setSelectedIndexDashboard] = useState(0);
  const [groupList, setGroupList] = useState([]);
  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardDescrList, setDashboardDescrList] = useState([]);
  const [fetchDashboardList, setFetchDashboardList] = useState(false);
  const [menuitemIndex, setMenuItemIndex] = useState(0);
  const [dashboardGroup, setDashboardGroup] = useState();
  const [dashboard, setDashboard] = useState();
  const [dashboardGroupIndex, setDashboardGroupIndex] = useState(null);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userGroupNameList = user.groupnamelist; // get list of assigned groups to logged user

  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);

  const widgetTypeMap = {
    DashboardView: {
      service1: DashboardViewService,
      source1: "DashboardList",
      menugroupnamelist: "dashboardgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    TableView: {
      service1: TableViewService,
      source1: "TableList",
      menugroupnamelist: "tablegroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    RecipeView: {
      service1: RecipeViewService,
      source1: "RecipeList",
      menugroupnamelist: "recipegroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    BatchData: {
      service1: BatchDataService,
      source1: "BatchList",
      menugroupnamelist: "recipegroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    AlarmView: {
      service1: AlarmViewService,
      source1: "AlarmList",
      menugroupnamelist: "alarmgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    TrendView: {
      service1: TrendViewService,
      source1: "TrendList",
      menugroupnamelist: "trendgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    ReportView: {
      service1: ReportViewService,
      source1: "ReportList",
      menugroupnamelist: "reportgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    ReportViewComplience: {
      service1: ReportViewComplienceService,
      source1: "ReportList",
      menugroupnamelist: "reportgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    AuditTrailView0: {
      service1: AuditTrailViewService,
      source1: "AuditTrailList",
      menugroupnamelist: "audittrailgroupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    UserManagement: {
      service1: UserManagementService,
      source1: "UserList",
      menugroupnamelist: "groupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    AuditTrailView: {
      service1: UserManagementService,
      source1: "UserList",
      menugroupnamelist: "groupnamelist",
      widgetname: "WidgetName",
      widgetdescription: "WidgetDescription",
    },
    // Add more types as needed
  };

  const widgetconfig = widgetTypeMap[dashboardType];
  //console.log(widgetconfig)

  const [payload, setPayload] = useState(null);
  const [menuList, setMenuList] = useState([]);
  const [menuListFecthDone, setMenuListFecthDone] = useState(false);

  // Get Menu and subMenu Position Configuration
  useEffect(() => {
    if (!dashboardType) return;
    //console.log(dashboardType);
    async function loadTableWidgetPositionConfig() {
      try {
        let dashboardName = "";
        if (dashboardType === "DashboardView") {
          dashboardName = "DashboardWidgetPositionConfig";
        }
        if (dashboardType === "TableView") {
          dashboardName = "TableWidgetPositionConfig";
        }
        if (dashboardType === "RecipeView") {
          dashboardName = "RecipeWidgetPositionConfig";
        }
        if (dashboardType === "BatchData") {
          dashboardName = "BatchDataWidgetPositionConfig";
        }
        if (dashboardType === "AlarmView") {
          dashboardName = "AlarmWidgetPositionConfig";
        }
        if (dashboardType === "TrendView") {
          dashboardName = "TrendWidgetPositionConfig";
        }
        if (dashboardType === "ReportView") {
          dashboardName = "ReportWidgetPositionConfig";
        }
        if (dashboardType === "ReportViewComplience") {
          dashboardName = "ReportComplienceWidgetPositionConfig";
        }
        if (dashboardType === "UserManagement") {
          dashboardName = "UserManagementWidgetPositionConfig";
        }
        if (dashboardType === "AuditTrailView") {
          dashboardName = "AuditTrailWidgetPositionConfig";
        }

        //console.log(dashboardType)
        //console.log(dashboardName)

        if (dashboardName !== "") {
          //console.log(dashboardName)
          const response =
            await ConfigurationViewService.getAllPayload(dashboardName);
          if (response.data) {
            //const cleanedData = (({ _id, __v, ...rest }) => rest)(response.data,);
            //console.log(response.data);
            setPayload(response.data);
            setMenuList(
              response.data
                .slice()
                .sort((a, b) => (a.menuPosition ?? 0) - (b.menuPosition ?? 0))
                .map((m) => m.menuName),
            );
            setMenuListFecthDone(true);
          } else {
            //console.log("Payload not received")
            setPayload(null);
            setMenuList([]);
            setMenuListFecthDone(true);
          }
        } else {
          setPayload(null);
          setMenuList([]);
          setMenuListFecthDone(true);
        }
      } catch (err) {
        console.error(err);
        setPayload(null);
        setMenuList([]);
        setMenuListFecthDone(true);
      }
    }

    if (dashboardType) {
      setMenuListFecthDone(false);
      loadTableWidgetPositionConfig();
    }
  }, [dashboardType]);

  // Function to sort groupName lsit as per menu list
  const sortMenuGroupByMenuList = (MenuGroupnameList, menuList) => {
    // If menuList is empty or invalid → return original list
    if (!Array.isArray(menuList) || menuList.length === 0) {
      return MenuGroupnameList;
    }

    // Items that exist in both lists (ordered by menuList)
    const ordered = menuList.filter((item) => MenuGroupnameList.includes(item));

    // Items NOT present in menuList (keep original order)
    const remaining = MenuGroupnameList.filter(
      (item) => !menuList.includes(item),
    );

    return [...ordered, ...remaining];
  };

  // Get grouplist from backend
  useEffect(() => {
    async function fetchGroupNames() {
      try {
        //console.log(widgetconfig)
        if (widgetconfig) {
          const {
            service1,
            source1,
            menugroupnamelist,
            widgetname,
            widgetdescription,
          } = widgetconfig;
          //console.log(source1)
          if(source1 === "BatchList"){
            let dashboardName = "RecipeGroupList"
            const response = await RecipeViewService.getAllRowsData(dashboardName);
            if (response){
              //console.log(response.data.map((item) => item.GroupName))
              //setBlockNameList(response.data.map((item) => item.GroupName));
              const MenuGroupnameList = response.data.map((item) => item.GroupName)
              //console.log(MenuGroupnameList)


              const sorted = sortMenuGroupByMenuList(MenuGroupnameList, menuList);
              setGroupList(sorted);
              setFetchDashboardList(true); 
            }

          }else{
            const response2 = await service1.getAllRowsData(source1);
            if (response2) {
              //console.log(projectName, dashboardType, selectedDashboardGroup, selectedDashboard);
              // Filter object and keep those one includes user groups assigned to current logged user
              const filteredData = response2.data.filter((obj) =>
                obj.groupnamelist.some((group) =>
                  userGroupNameList.includes(group),
                ),
              );

              // get the list of dashboard group which are present in filteredData as per user groups assigned to current user
              // removed duplicate entries by using ..new set
              const MenuGroupnameList = [
                ...new Set(filteredData.flatMap((obj) => obj[menugroupnamelist])),
              ];

              //console.log(userGroupNameList);
              //console.log(MenuGroupnameList);
              //console.log(menuList);
              const sorted = sortMenuGroupByMenuList(MenuGroupnameList, menuList);

              //setGroupList(MenuGroupnameList.sort());
              setGroupList(sorted);
              setFetchDashboardList(true);
            }

          }
          
          
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (menuListFecthDone === true) {
      fetchGroupNames();
    }
  }, [menuListFecthDone]);

  // Function to get sorted submenus for selcetd menu
  const sortDashboardBySubMenuList = (dasbrdList, subMenuList) => {
    if (!Array.isArray(subMenuList) || subMenuList.length === 0) {
      return dasbrdList;
    }

    const ordered = subMenuList.filter((item) => dasbrdList.includes(item));

    const remaining = dasbrdList.filter((item) => !subMenuList.includes(item));

    return [...ordered, ...remaining];
  };

  // get widgetlsit from backend to display initially
  useEffect(() => {
    async function fetchDashboardNames() {
      if (widgetconfig) {
        const {
          service1,
          source1,
          menugroupnamelist,
          widgetname,
          widgetdescription,
        } = widgetconfig;
        const response2 = await service1.getAllRowsData(source1);

        if (response2) {
          //console.log(response2.data);

          // 1 Filter by selected menu group
          const dashboardlistofSelectedGroup = response2.data.filter((obj) => 
            obj[menugroupnamelist]?.includes(groupList[0]), );
      

          // 2 Filter by user group access
          const filteredObjects2 = dashboardlistofSelectedGroup.filter((obj) =>
            obj.groupnamelist.some((value) =>
              userGroupNameList.includes(value),
            ),
          );

          // 3 Create single list keeping name & description together
          const dashboardItems = filteredObjects2.map((item) => ({
            name: item[widgetname],
            description: item[widgetdescription],
          }));

          // 4 Get submenu list from payload
          const selectedMenuConfig = payload?.find(
            (item) => item.menuName === groupList[0],
          );

          const subMenuList =
            selectedMenuConfig?.subMenus
              ?.slice()
              .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
              .map((sub) => sub.name) || [];

          // 5 Reorder dashboards based on submenu order
          const orderedItems = subMenuList
            .map((menu) => dashboardItems.find((d) => d.name === menu))
            .filter(Boolean);

          // 6 Append dashboards not present in submenu list
          const remainingItems = dashboardItems.filter(
            (d) => !subMenuList.includes(d.name),
          );

          const finalItems = [...orderedItems, ...remainingItems];

          // 7 Extract sorted name & description lists
          const sortedA = finalItems.map((item) => item.name);
          const sortedB = finalItems.map((item) => item.description);

          //console.log(sortedA); // Widget Names
          //console.log(sortedB); // Matching Descriptions

          selectedDashboard(sortedA[0]);
          dispatch(setGroupName(groupList[0]));
          dispatch(setWidgetName(sortedA[0]));
          dispatch(setWidgetDescription(sortedB[0]));
        }
      }
    }

    if (fetchDashboardList === true) {
      fetchDashboardNames();
    }
  }, [fetchDashboardList]);

  // Toggle main menu on button click
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    setSubMenuOpen(false); // always reset submenu when toggling
  };

  // Click main menu item — open submenu and fetch dashboard names
  const handleMenuItemClick = (index) => {
    //console.log(index);
    const selectedGroup = groupList[index];
    //setSelectedIndex(index);
    setDashboardGroupIndex(index); // Track selected group for later us
    setDashboardGroup(selectedGroup);
    setSubMenuAnchorEl(document.getElementById(`menu-item-${index}`));
    setSubMenuOpen(true);
  };

  // Fetch dashboards from backend when group is selected
  useEffect(() => {
    async function fetchDashboardNames() {
      if (widgetconfig && dashboardGroup) {
        const {
          service1,
          source1,
          menugroupnamelist,
          widgetname,
          widgetdescription,
        } = widgetconfig;

        const response2 = await service1.getAllRowsData(source1);

        // For batchData removed batch record where 
        // CurrentBatchStage is undefined or "2"(STOP) or "6" (ABORT or end of profile occured)
        if (dashboardType === "BatchData") {
          response2.data = response2.data.filter(
            (item) =>
              item.BatchEndTime == ''
              //item.BatchCurrentStage !== undefined &&
              //item.BatchCurrentStage !== "2" &&
              //item.BatchCurrentStage !== "6"
          );
          //console.log(service1, source1);
          //console.log(service1, source1, menugroupnamelist, widgetname, widgetdescription);
          //console.log("Filtered BatchList:", response2.data);
        }
        

        if (response2) {
          //console.log(response2.data);

          // 1 Filter by selected menu group
          const dashboardlistofSelectedGroup = response2.data.filter((obj) =>
            obj[menugroupnamelist]?.includes(dashboardGroup),
          );

          // 2 Filter by user group access
          const filteredObjects2 = dashboardlistofSelectedGroup.filter((obj) =>
            obj.groupnamelist.some((value) =>
              userGroupNameList.includes(value),
            ),
          );

          // 3 Create single list keeping name & description together
          const dashboardItems = filteredObjects2.map((item) => ({
            name: item[widgetname],
            description: item[widgetdescription],
          }));

          // 4 Get submenu list from payload
          const selectedMenuConfig = payload?.find(
            (item) => item.menuName === dashboardGroup,
          );

          const subMenuList =
            selectedMenuConfig?.subMenus
              ?.slice()
              .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
              .map((sub) => sub.name) || [];

          // 5 Reorder dashboards based on submenu order
          const orderedItems = subMenuList
            .map((menu) => dashboardItems.find((d) => d.name === menu))
            .filter(Boolean);

          // 6 Append dashboards not present in submenu list
          const remainingItems = dashboardItems.filter(
            (d) => !subMenuList.includes(d.name),
          );

          const finalItems = [...orderedItems, ...remainingItems];

          // 7 Extract sorted name & description lists
          const sortedA = finalItems.map((item) => item.name);
          const sortedB = finalItems.map((item) => item.description);

          //console.log(sortedA); // Widget Names
          //console.log(sortedB); // Matching Descriptions

          setDashboardList(sortedA);
          setDashboardDescrList(sortedB);

          /* NEW LOGIC: If only one submenu item → auto select */
          if (sortedA.length === 1) {
            setSelectedIndex(dashboardGroupIndex); // Save the group label
            setSelectedIndexDashboard(0);
            setOpen(false);
            setSubMenuOpen(false);

            selectedDashboardGroup(dashboardGroup);
            selectedDashboard(sortedA[0]);

            dispatch(setGroupName(dashboardGroup));
            dispatch(setWidgetName(sortedA[0]));
            dispatch(setWidgetDescription(sortedB[0]));
          } 
        }
      }
    }

    if (dashboardGroup) {
      fetchDashboardNames();
    }
  }, [dashboardGroup]);

  // Click submenu item — select and close all menus
  const handleSubMenuItemClick = (index) => {

    setSelectedIndex(dashboardGroupIndex); // Save the group label
    setSelectedIndexDashboard(index);
    setOpen(false);
    setSubMenuOpen(false);

    selectedDashboardGroup(dashboardGroup);
    selectedDashboard(dashboardList[index]);

    dispatch(setGroupName(dashboardGroup));
    dispatch(setWidgetName(dashboardList[index]));
    dispatch(setWidgetDescription(dashboardDescrList[index]));
  };

  // ClickAway: close both menus
  const handleClose = () => {
    setOpen(false);
    setSubMenuOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup variant="text" size="small" ref={anchorRef}>
        <Button
          size="small"
          color="success"
          onClick={handleToggle}
          style={{ textTransform: "none" }}
        >
          {groupList[selectedIndex] || "Select Group"}
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      {/* Main Menu Popper */}
      <Popper
        sx={{ zIndex: 10 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: "top left" }}>
            <Paper sx={{ minHeight: "100px", minWidth: "150px", padding: 1 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem>
                  {groupList.map((option, index) => (
                    <MenuItem
                      id={`menu-item-${index}`}
                      key={option}
                      selected={index === selectedIndex}
                      onClick={() => handleMenuItemClick(index)}
                      style={{ textTransform: "none" }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {/* Submenu Popper */}
      <Popper
        sx={{ zIndex: 11 }}
        open={subMenuOpen}
        anchorEl={subMenuAnchorEl}
        role={undefined}
        transition
        disablePortal={false}
        placement="right-start"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: "left top" }}>
            <Paper
              sx={{
                minHeight: "150px",
                minWidth: "150px",
                //maxWidth: 200,
                maxHeight: "80vh",
                overflowY: "auto",
                textOverflow: "ellipsis",
                padding: 1,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem>
                  {dashboardList.map((item, index) => (
                    <MenuItem
                      key={item}
                      selected={index === selectedIndexDashboard}
                      onClick={() => handleSubMenuItemClick(index)}
                      style={{ textTransform: "none" }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
